<script setup>
  import CompleteReportHeaderSecondaryActionList from '@/components/CompleteReportHeaderSecondaryActionList.vue';

  const showSettingsModal = defineModel('showSettingsModal', { required: true });
</script>

<template>
  <div class="jwx-page-header__secondary-content jwx-page-block jwx-page-block--padding-sm">
    <CompleteReportHeaderSecondaryActionList
      v-model:showSettingsModal="showSettingsModal"
    />
  </div>
</template>